import { useLang } from "../i18n/LanguageContext";
import { EMBEDS, IMAGES } from "../i18n/content";
import { Reveal, Overline } from "../components/Reveal";
import { PageIntro } from "../components/PageIntro";
import { LazyEmbed } from "../components/LazyEmbed";
import { FinalCTA } from "../components/FinalCTA";
import { ArrowUpRight } from "lucide-react";

export default function Music() {
  const { t } = useLang();
  return (
    <>
      <PageIntro overline={t("music.overline")} title={t("music.title")} body={t("music.body")} testId="music-intro" />

      <section className="bg-cream pb-24 lg:pb-32" data-testid="music-body">
        <div className="mx-auto max-w-6xl px-6 lg:px-10">
          <Reveal>
            <div className="mb-8 flex items-center justify-between">
              <Overline>{t("music.soundcloudTitle")}</Overline>
              <a href={EMBEDS.soundcloudProfile} target="_blank" rel="noopener noreferrer" data-testid="music-sc-more" className="inline-flex items-center gap-2 text-sm font-semibold text-terracotta">
                {t("music.more")} <ArrowUpRight className="h-4 w-4" />
              </a>
            </div>
          </Reveal>

          <div className="space-y-8">
            <Reveal>
              <LazyEmbed type="soundcloud" url={EMBEDS.soundcloudUrl} poster={IMAGES.moodTexture} title="SoundCloud mix — main" testId="music-soundcloud-1" />
            </Reveal>
            <Reveal delay={0.08}>
              <LazyEmbed type="soundcloud" url={EMBEDS.soundcloudUrl} poster={IMAGES.gallery[2].src} title="SoundCloud mix — sunset" testId="music-soundcloud-2" />
            </Reveal>
          </div>
        </div>
      </section>

      <FinalCTA />
    </>
  );
}
